import ReactQuill from 'react-quill-new';

const READ_ONLY_MODULES = { toolbar: false };

type ReadOnlyQuillProps = {
  value: ReactQuill.Value | undefined;
  className?: string;
};

export const ReadOnlyQuill = ({ value, className }: ReadOnlyQuillProps) => {
  return (
    <ReactQuill
      modules={READ_ONLY_MODULES}
      value={value}
      readOnly={true}
      theme="snow"
      className={className}
    />
  );
};
